// removed by extract-text-webpack-plugin
module.exports = {"visible-xs":"visible-xs___V7ah8","visible-sm":"visible-sm___F2-Vi","visible-md":"visible-md___3U8ne","visible-lg":"visible-lg___WDJzM","row":"row___2JEVD","hidden-xs":"hidden-xs___1TZc8","hidden-sm":"hidden-sm___2rvmQ","hidden-md":"hidden-md___28O7U","hidden-lg":"hidden-lg___1SMkc","flex":"flex___aztgp space-top-12___3DU92 space-bottom-12___rGCm0 center___2iqBf","img":"img___pSeYR","copy":"copy___N4hEZ center___2iqBf","title":"title___3KEBb h2___hzLuT space-bottom-6___3i22S","lede":"lede___2gycD h3___5u0xZ space-top-6___2l-qx space-bottom-6___3i22S","button":"button___1DTw8 h3___5u0xZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PartnerSites/PartnerSites.css
// module id = 850
// module chunks = 0